import { Badge, Form, Input, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useLazySingleVacationQuery } from 'app/services/edpApiV1/vacations';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { dataObjectForTable, dataObjectForVacationTable } from 'shared/helpers/utils';
import { PresetStatusColorType } from 'antd/lib/_util/colors';
import { TPreparedVacationData, TPreparedVacationTableData } from 'shared/types/vacations.types';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useAppSelector } from 'app/store';
import VacationsComments from '../vacationsComments';
import style from './index.module.scss';

/**
 * @page Vacation user archive
 */

const columns: ColumnsType<TPreparedVacationTableData> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Вид отпуска',
    dataIndex: 'vacationType',
    key: 'vacationType',
  },
  {
    title: 'Тип заявления',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Дата начала',
    dataIndex: 'startedAt',
    key: 'startedAt',
  },
  {
    title: 'Дата окончания',
    dataIndex: 'endedAt',
    key: 'endedAt',
  },
  {
    title: 'Дни',
    dataIndex: 'amountDays',
    key: 'amountDays',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: (status: { type?: PresetStatusColorType; text: string; isSupervisorApproved: boolean }) => (
      <span className="d-flex">
        <Badge className={style.badge} status={status.type} />
        {status.text}
      </span>
    ),
  },
];

const VacationUserArchive = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [dataVacations, setDataVacations] = useState<TPreparedVacationData[] | []>([]);
  const tableData = useRef<TPreparedVacationTableData[]>();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [getSingleVacation, { data, isLoading }] = useLazySingleVacationQuery();

  useEffect(() => {
    if (id) {
      getSingleVacation({ requestId: id, allAvailableOrganizations });
    }
  }, [id, getSingleVacation, allAvailableOrganizations]);

  useEffect(() => {
    if (data && id) {
      const dataNew = data;
      const dataTable = dataObjectForTable(dataNew);
      const dataForTable = dataObjectForVacationTable(dataNew);
      if (dataForTable) {
        tableData.current = dataForTable;
      }
      if (dataTable) {
        setDataVacations(dataTable);
      }
    }
  }, [data, id]);

  useEffect(() => {
    if (dataVacations && dataVacations?.length > 0) {
      form.setFields([
        {
          name: 'tabel',
          value: dataVacations[0]?.employee?.personnelNumber,
        },
        {
          name: 'division',
          value: dataVacations[0]?.employee?.division,
        },
        {
          name: 'position',
          value: dataVacations[0]?.employee?.position,
        },
      ]);
    }
  }, [dataVacations, form]);

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <div className={style.wrap}>
          <Table scroll={{ x: true }} dataSource={tableData.current} columns={columns} pagination={false} bordered />

          <Form form={form} layout="vertical" name="userInfo" className={style.userInfo}>
            <div className={style.groupItem}>
              <Form.Item name="tabel" label="Табельный номер" labelAlign="left" className={style.inputWrap}>
                <Input className="userInput" disabled />
              </Form.Item>
              <Form.Item name="division" label="Подразделение" labelAlign="left" className={style.inputWrap}>
                <Input className="userInput" disabled />
              </Form.Item>
            </div>
            <div className={style.groupItem}>
              <Form.Item name="position" label="Должность" labelAlign="left" className={style.inputWrap}>
                <Input className="userInput" disabled />
              </Form.Item>
            </div>
          </Form>
        </div>
      )}

      {dataVacations && dataVacations[0]?.status?.text === 'Отклонено HR' && (
        <VacationsComments commentsData={dataVacations[0]?.rejectionReason} />
      )}
    </>
  );
};

export default VacationUserArchive;
